var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29541 20.1591C7.29541 19.3307 7.96698 18.6591 8.79541 18.6591C9.62384 18.6591 10.2954 19.3307 10.2954 20.1591C10.2954 20.9875 9.62384 21.6591 8.79541 21.6591C7.96698 21.6591 7.29541 20.9875 7.29541 20.1591Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7954 20.1591C16.7954 19.3307 17.467 18.6591 18.2954 18.6591C19.1238 18.6591 19.7954 19.3307 19.7954 20.1591C19.7954 20.9875 19.1238 21.6591 18.2954 21.6591C17.467 21.6591 16.7954 20.9875 16.7954 20.1591Z",
    fill: "#8395A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3C1.25 2.58579 1.58579 2.25 2 2.25H5.45455C5.81202 2.25 6.1198 2.50229 6.18996 2.85281L6.93359 6.56818H21C21.2235 6.56818 21.4354 6.66788 21.5779 6.8401C21.7204 7.01232 21.7786 7.23911 21.7367 7.45868L20.3538 14.7102C20.2406 15.2805 19.9303 15.7927 19.4774 16.1573C19.0266 16.5202 18.4629 16.7138 17.8844 16.7045H9.50287C8.92433 16.7138 8.3607 16.5202 7.90985 16.1573C7.45706 15.7928 7.14686 15.2807 7.03354 14.7106L5.59022 7.4994C5.58479 7.47751 5.58032 7.45524 5.57686 7.43263L4.83978 3.75H2C1.58579 3.75 1.25 3.41421 1.25 3ZM7.23381 8.06818L8.50472 14.418C8.5494 14.6429 8.67179 14.845 8.85045 14.9889C9.02912 15.1327 9.25268 15.2091 9.48199 15.2047L9.49636 15.2045H17.8909L17.9053 15.2047C18.1346 15.2091 18.3582 15.1327 18.5368 14.9889C18.7149 14.8455 18.837 14.6444 18.8821 14.4204L18.8826 14.418L20.0935 8.06818H7.23381Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.500093135ecf0a42348b4f2a5a51fde2.svg";
export { ForwardRef as ReactComponent };